import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from "@/components/ui/carousel";
import type { Data } from "@/types/data";
import NavItem from "./nav-item";

interface HeroProps {
	data: Data;
}

export default function Hero({ data }: HeroProps) {
	const activeBanners = data["area-inicial"].carrossel.banners.filter(
		(banner) => banner.ativo,
	);
	const banners = activeBanners.length
		? activeBanners
		: data["area-inicial"].carrossel.banners;

	if (!banners.length) {
		return null;
	}

	return (
		<section id="top" className="relative bg-zinc-950">
			<Carousel className="w-full" opts={{ loop: true }}>
				<CarouselContent className="-ml-0">
					{banners.map((banner, index) => (
						<CarouselItem key={`${banner.imagem}-${index}`} className="pl-0">
							<article className="relative min-h-[520px] overflow-hidden md:min-h-[620px]">
								<img
									src={`/slides/${banner.imagem}`}
									alt=""
									aria-hidden="true"
									loading={index === 0 ? "eager" : "lazy"}
									className="absolute inset-0 h-full w-full object-cover object-center"
								/>

								<div
									className="absolute inset-0 bg-gradient-to-r from-zinc-950/95 via-zinc-950/65 to-zinc-950/25"
									aria-hidden="true"
								/>

								<div className="relative mx-auto flex min-h-[520px] max-w-7xl items-end px-4 pb-14 pt-16 sm:px-6 md:pb-20 lg:px-8">
									<div className="max-w-2xl p-6 text-white md:p-8">
										<p className="animate-fade-up text-sm font-semibold uppercase tracking-wide text-brand-secondary-200">
											{data["area-inicial"].mensagem}
										</p>
										<h1 className="animate-fade-up animate-fade-up-delay-1 mt-3 text-3xl font-semibold leading-tight text-balance sm:text-4xl md:text-5xl">
											{banner.titulo}
										</h1>
										<p className="animate-fade-up animate-fade-up-delay-2 mt-4 max-w-xl text-sm leading-relaxed text-zinc-200 sm:text-base">
											{banner.descricao}
										</p>

										<div className="mt-7 flex flex-col gap-3 sm:flex-row">
											<div className="inline-flex items-center justify-center rounded-md bg-brand-500 px-5 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-brand-700 active:scale-[0.97]">
												<NavItem
													data={data}
													label={banner.label}
													href={banner.href}
													className="inline-flex items-center"
												/>
											</div>
											{banner.url && (
												<a
													href={banner.url}
													target="_blank"
													rel="noopener noreferrer"
													className="inline-flex items-center justify-center rounded-md border border-zinc-200/60 bg-white/10 px-5 py-3 text-sm font-semibold text-zinc-100 transition-colors hover:bg-white/20"
												>
													Saiba mais
												</a>
											)}
										</div>
									</div>
								</div>
							</article>
						</CarouselItem>
					))}
				</CarouselContent>
				<CarouselPrevious className="left-3 hidden border-white/40 bg-white/90 text-zinc-900 hover:bg-white md:inline-flex" />
				<CarouselNext className="right-3 hidden border-white/40 bg-white/90 text-zinc-900 hover:bg-white md:inline-flex" />
			</Carousel>
		</section>
	);
}
